import React, { Component } from 'react';
import { TextField, ToolTip } from './eventFormComponents';
import * as styled from '../../styles/style';
import { validator, errorMessages } from '../../helpers/validation';
import CopyToClipboardButton from '../CopyToClipboardButton';
import ButtonLinkExternal from '../generic/ButtonLinkExternal'
import styledComponent from 'styled-components'
import * as variables from '../../styles/variables';

const Wrapper = styledComponent.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  @media (max-width: ${variables.breakpoints.mobile}) {
    flex-direction: column;
  }

  .first-name, .last-name {
    width: 20%;
    @media (max-width: ${variables.breakpoints.mobile}) {
      width: 100%;
    }
  }

  .email-field {
    width: 60%;
    @media (max-width: ${variables.breakpoints.mobile}) {
      width: 100%;
    }
  }
`

const Hint = styledComponent.div`
  color: grey;
`

class GuestItem extends Component {
	constructor(props) {
    super(props);

    const guestCopy = {};
    Object.assign(guestCopy, props.guest);

    this.state = {
      editing: false,
      guest: props.guest,
      baseGuestState: guestCopy,
      warnings: {},
      deleting: false,
    }
    // preserve the initial state in a new object
  }

  static getDerivedStateFromProps(props, state) {
    const guestCopy = {};
    Object.assign(guestCopy, props.guest);
    
    return {
      guest: props.guest,
      baseGuestState: guestCopy,
    };
  }

  handleEdit = () => {
  	this.setState({
  		editing: true,
      deleting: false,
  	});
  }

  handleSave = () => {
  	this.props.updateGuest(this.state.guest)
  	this.setState({
  		editing: false,
      deleting: false,
  	});
  }

  handleCancel = () => {
    const guestCopy = {};
    Object.assign(guestCopy, this.state.baseGuestState);
    this.setState({
      editing: false,
      deleting: false,
      warnings: {},
      guest: guestCopy,
    });
  }

  handleRSVPNo = () => {
  	this.props.updateGuest({status: 'no', id: this.props.guest.id});
  	this.setState({
  		editing: false,
  	});
  }

  handleRSVPYes = () => {
  	this.props.updateGuest({status: 'yes', id: this.props.guest.id});
  	this.setState({
  		editing: false,
    });
  }

  handleSendInvite = () => {
    this.props.updateGuest({status: 'invited', id: this.props.guest.id}, true);
  }

  handleRemove = () => {
    this.setState({
      deleting: true,
    });
  }

  confirmRemoveGuest = () => {
    this.props.removeGuest(this.state.guest);
    this.setState({
      editing: false,
    });
  }

  cancelRemoveGuest = () => {
    this.setState({
      deleting: false,
    });
  }

  validateGuestChange = (name, value) => {
    switch(name) {
      case 'email':
        return validator.isEmail(value);
      default:
        return value !== '';
    }
  }

  handleGuestChange = (event) => {
    let name, warning_name;
    let { guest } = this.state;
    name = warning_name = event.target.name;
    guest[name] = event.target.value;

    this.setState({
      guest: guest
    });

    if (this.validateGuestChange(name, event.target.value)) {
      this.setWarningMessage(name, '');
    }
    else {
      if (name === 'email' && event.target.value === '') {
        warning_name = 'email_required';
      } else if (name === 'email' && event.target.value !== '') {
        warning_name = 'email';
      }
      this.setWarningMessage(name, errorMessages[warning_name]);
    }
  }

  setWarningMessage = (name, message) => {
    let warning = this.state.warnings;
    warning[name] = message;

    this.setState({
      warnings: warning
    })
  }

  statusLabel(status) {
    switch(status) {
      case 'invited':
        return 'Invited';
      case 'yes':
        return 'RSVP Yes';
      case 'no':
        return 'RSVP No';
      default:
        return '';
    }
  }

  validateEmail(email) {
    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  }

  render() {
    const { guest, editing, deleting } = this.state;
    const statusLabel = this.statusLabel(guest.status);

    const baseURL = window.location.protocol + '//' + window.location.hostname + (window.location.port ? ':' + window.location.port : '');
    const rsvpURL = baseURL + '/api/guests/rsvp?token=' + guest.token;

    const validEmail = guest.email && this.validateEmail(guest.email)

    if (!editing) {
    	let statusContent;
      let actionsContent;
    	if (guest.status === 'waitlist') {
	    	statusContent = (<styled.MiniButton onClick={this.handleSendInvite}>Send Invitation</styled.MiniButton>);
        actionsContent = (<span className="actions">
              <a onClick={this.handleEdit} style={{display: 'block'}}>Update Info</a>
            </span>);
	    } else {
	    	statusContent = statusLabel;
        actionsContent = (<span className="actions">
              <a onClick={this.handleEdit} style={{display: 'block'}}>Update Info/RSVP</a>
            </span>);
	    }
      return (
    		<styled.GuestItem>
					<div style={{width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'space-between'}}>
	    			<span className="full-name">{guest.first_name} {guest.last_name}</span>
	    			<span className="email">{guest.email}</span>
            {actionsContent}
            {/*guest.message && <ToolTip linkText='View Message'>{guest.message}</ToolTip>*/}
					</div>
  			</styled.GuestItem>
	    );
    } else {
    	return (
        <styled.GuestItem>
					<Wrapper>
	      	  <styled.HalfWidthFieldGroup className="small-text first-name" style={{marginBottom: "16px"}}>
	            <TextField value={guest.first_name} name='first_name' label='First' update={this.handleGuestChange} required={true}/>
	          </styled.HalfWidthFieldGroup>
	          <styled.HalfWidthFieldGroup className="small-text last-name" style={{marginBottom: "16px"}}>
	            <TextField value={guest.last_name} name='last_name' label='Last' update={this.handleGuestChange} required={true}/>
	          </styled.HalfWidthFieldGroup>
	          <styled.HalfWidthFieldGroup className="small-text email-field" style={{marginBottom: "16px"}}>
	            <TextField value={guest.email} name='email' label='Email' update={this.handleGuestChange} required={true}/>
	          </styled.HalfWidthFieldGroup>
					</Wrapper>
					<div style={{width: '100%', display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between'}}>
            { guest.status !== 'no' ? 
              <ButtonLinkExternal tiny secondary onClick={this.handleRSVPNo} style={{marginRight: '8px'}}>
                Change to Not Attending
              </ButtonLinkExternal> : '' 
            }
	          { guest.status !== 'yes' ? 
              <div style={{display: "flex", flexDirection: "column", alignItems: "flex-start"}}>
                <ButtonLinkExternal tiny secondary onClick={this.handleRSVPYes} style={{marginRight: '32px', marginBottom: '16px'}} disabled={!validEmail}>
                  Change to Attending
                </ButtonLinkExternal> 
                {!validEmail && <Hint>You must provide a valid guest email address to move them to the attendees list</Hint>}
              </div> : '' 
            }
	          <ButtonLinkExternal tiny onClick={this.handleSave} style={{marginRight: '0px'}}>Done</ButtonLinkExternal>
          </div>
        </styled.GuestItem>
      );
    }
  }
}

export default GuestItem;
